/** @module Specification/PartMaterialColor/PMCColorSupplierCodeRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/html",
	"csi/xml"
], function(declare,StringRen,html,xml) {

	var COLOR_CODES = "ColorCodes";

	return declare([StringRen], {

		/**
		 * @override
		 * Handles display of supplier code on PartMaterial.CommonColor and PartMaterialColor.PMCColor based on custom view setting for Display Supplier Codes
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			if (!ctx.view.displaySupplierCodes) {
				return false;
			}

			var cache = ctx.cache;
			var node = ctx.getNode();
			var color = cache.get(node.CommonColor) || cache.get(node.PMCColor);
			var quote = cache.get(node.BOMLineQuote) || cache.get(node.PMCQuote);
			if (color && quote) {
				var productSource = cache.get(quote.__Parent__);
				var codes = productSource && productSource.ColorCodes;
				var code = codes && codes[color.SysID];
				if (code) {
					html.setInnerText(refNode, "("+ code +")");
				}
			}
			return true;
		}

	});
});